import { render, staticRenderFns } from "./PersonMatch.vue?vue&type=template&id=3050cb82&scoped=true"
import script from "./PersonMatch.vue?vue&type=script&lang=js"
export * from "./PersonMatch.vue?vue&type=script&lang=js"
import style0 from "./PersonMatch.vue?vue&type=style&index=0&id=3050cb82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3050cb82",
  null
  
)

export default component.exports